import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Divider, Row, Col, Typography, Tag, Alert, Table, Button } from 'antd'
import ReactHtmlParser from 'react-html-parser';
import { ConvertCustomerScheduleType, isValidDate, ConvertCustomerScheduleStatus } from '@/utils/helpers';
import { isMobile } from 'react-device-detect';
import HtmlParser from 'react-html-parser';
import { EditOutlined } from '@ant-design/icons';
import NoteForm from '../appointment/NoteForm';
import { getTreatmentNoteDetail } from '@/redux/actions/treatmentNoteActions';
import { getSpecificCustomer } from '@/redux/actions/customerActions';

const { Paragraph } = Typography;

class ScheduleDetail extends Component {

    constructor() {
        super();
        this.state = {
            isOpenEditForm: false,
            isOpenStatusForm: false,
            currentNote: null,
            isOpenFormNote: false,
            customer: null
        };
    }

    handleCancel() {
        this.props.onCancel();
    }

    handleEdit(isOpenFormNote, id) {
        this.props.getTreatmentNoteDetail(id)
            .then(note => {
                this.setState({ isOpenFormNote, currentNote: note });

                if (note && note.customer_id) {
                    return this.props.getSpecificCustomer(note.customer_id);
                }
                return Promise.resolve(null);
            })
            .then(customer => {
                if (customer) {
                    this.setState({ customer });
                }
            })
            .catch(error => {
                console.error('Error in handleEdit:', error);
            });
    }

    onCancelFormNote() {
        this.setState({ isOpenFormNote: false, currentNote: null });
    }

    // Ngày mai check quyền update trong d/s ở 2 file CustomerDetail.js, scheduleDetail.js

    render() {
        var { visible, currentItem } = this.props;
        var { currentNote, isOpenFormNote, customer } = this.state

        //console.log('currentItem', currentItem);

        const createColumns = (timeField, resultField) => [
            {
                title: 'Thời điểm tư vấn',
                dataIndex: timeField,
                key: timeField,
                width: '140px',
                render: (text) => {
                    return text ? (
                        <div>{isValidDate(text)}</div>
                    ) : (
                        <Tag>N/A</Tag>
                    );
                }
            },
            {
                title: 'Kết quả tư vấn',
                dataIndex: resultField,
                key: resultField,
                width: '300px',
                maxWidth: '300px',
                render: (text, record) => {
                    return <>{HtmlParser(record[resultField])}</>;
                }
            }
        ];

        const columns = createColumns('time_telesale', 'result_content');
        const columns2 = createColumns('time_consultant', 'result_content');


        const columns3 = [
            {
                title: 'Nội dung',
                dataIndex: 'content',
                key: 'content',
                width: '250px',
                render: (text, record) => {
                    return (
                        <>{HtmlParser(record.content)}</>
                    )
                }
            },
            {
                title: 'Người nhập',
                dataIndex: 'created_by',
                key: 'created_by',
                width: '150px',
                render: (text, record) => {
                    return (
                        <>{record?.created_by?.full_name}</>
                    )
                }
            },
            {
                title: 'Bác sĩ xác nhận',
                dataIndex: 'confirmed_by',
                key: 'confirmed_by',
                width: '150px',
                render: (text, record) => {
                    return (
                        <>{record?.confirmed_by?.full_name}</>
                    )
                }
            },
            {
                title: 'Ngày tạo',
                dataIndex: 'created_at',
                key: 'created_at',
                width: '150px',
                render: (text, record) => {
                    return (
                        <>{isValidDate(record.created_at)}</>
                    )
                }
            },
            {
                title: '#',
                align: 'center',
                width: '50px',
                dataIndex: 'actions',
                key: 'actions',
                render: (text, record) => {
                    return (
                        <>
                            <Button
                                size="small"
                                type="dashed"
                                className='btn-edit'
                                icon={<EditOutlined />}
                                onClick={() => this.handleEdit(true, record.id)}
                            >Sửa</Button>
                        </>
                    );
                }
            }
        ];


        return (
            <>
                <Drawer
                    visible={visible}
                    title={`Chi tiết lịch hẹn`}
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '55%'}
                >
                    {visible ? (
                        <div>
                            <Table
                                className='mb-4 custom-table'
                                title={() => <>Ghi chú điều trị</>}
                                rowKey="id"
                                size="small"
                                dataSource={currentItem?.customer?.treatment_note || []}
                                columns={columns3}
                                pagination={false}
                                scroll={{
                                    x: 'max-content'
                                }}
                                locale={{ emptyText: "Chưa có dữ liệu" }}
                            />
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Kiểu lịch hẹn">
                                            {currentItem ? ConvertCustomerScheduleType(currentItem.name) : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Tên khách hàng">
                                            {currentItem ? currentItem.customer_name : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Mã khách hàng">
                                            <Paragraph style={{ margin: 0 }} copyable={
                                                {
                                                    text: currentItem ? currentItem.customer_code : null,
                                                    tooltips: false
                                                }
                                            }>
                                                <Tag color='#1890ff'>{currentItem ? currentItem.customer_code : null}</Tag>
                                            </Paragraph>
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Cơ sở">
                                            {currentItem ? currentItem.branch_name : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Thời gian">
                                            {isValidDate(currentItem.time)}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label={`Thời điểm ${currentItem.name == 'GOILAI' ? 'gọi' : 'đến'}`}>
                                            {isValidDate(currentItem?.time_to)}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Trạng thái">
                                            {currentItem ? ConvertCustomerScheduleStatus(currentItem.status) : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Cập nhật trạng thái">
                                            {currentItem ? currentItem.updated_user : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Nhân viên tư vấn trực tiếp">
                                            {currentItem ? currentItem?.staff_consultant_direct : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Bác sĩ thực hiện">
                                            {currentItem ? currentItem?.doctors : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Ngày tạo">
                                            {isValidDate(currentItem.created_at)}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Người tạo">
                                            {currentItem ? currentItem.created_user : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                </Col>
                            </Row>
                            <Row gutter={16} className='mt-3'>
                                <Col xs={24} md={24}>
                                    <Alert
                                        message={<span style={{ fontWeight: '600' }}>Ghi chú của khách hàng</span>}
                                        description={currentItem ? ReactHtmlParser(currentItem.customer_note) : null}
                                        type="info"
                                        className='fix-alert-element'
                                    />
                                </Col>
                            </Row>
                            <Row gutter={16} className='mt-3'>
                                <Col xs={24} md={24}>
                                    <h6 className="h6-title">Ghi chú lịch hẹn:</h6>
                                    {currentItem ? ReactHtmlParser(currentItem.note) : null}
                                    <Divider className="no-margin mt-3" />
                                </Col>
                            </Row>
                            <Table
                                className='mt-4 custom-table'
                                title={() => <>Kết quả telesale</>}
                                rowKey="id"
                                size="small"
                                dataSource={currentItem?.telesale}
                                columns={columns}
                                pagination={false}
                                scroll={{
                                    x: 'max-content'
                                }}
                                locale={{ emptyText: "Chưa có dữ liệu" }}
                            />
                            <Table
                                className='mt-4 mb-4  custom-table'
                                title={() => <>Kết quả tư vấn trực tiếp</>}
                                rowKey="id"
                                size="small"
                                dataSource={currentItem?.consultant_direct}
                                columns={columns2}
                                pagination={false}
                                scroll={{
                                    x: 'max-content'
                                }}
                                locale={{ emptyText: "Chưa có dữ liệu" }}
                            />
                        </div>
                    ) : null}

                </Drawer>

                <NoteForm
                    visible={isOpenFormNote}
                    currentItem={customer}
                    currentNote={currentNote}
                    onCancel={() => this.onCancelFormNote()}
                />
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getTreatmentNoteDetail: (id) => dispatch(getTreatmentNoteDetail(id)),
        getSpecificCustomer: (id) => dispatch(getSpecificCustomer(id)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'ScheduleDetail' })(ScheduleDetail));
